import { canv } from "@/canv/global";
import { TextWidgetV2 } from "@/elements/text/textV2";
import { Group } from "@/group";
import { toolBase } from "@/tools/toolBase";

export class textTool extends toolBase {
    getToolView() {
        return `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 7V5H19V7M12 5V19M12 19H14M12 19H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        `;
    }

    getToolTipName() {
        return "Текст";
    }

    getToolHotKey() {
        return "T";
    }

    setColor(color: string) {
        this.color = color;
    }

    createText() {
        const pt = canv.actionManager.getActionPoint();

        const creationStartX = pt.x;
        const creationStartY = pt.y;

        const newTextItem = new TextWidgetV2(creationStartX, creationStartY);

        const newGroup = new Group(true);
        newTextItem.setParent(newGroup);
        canv.canvasController.addGroup(newGroup);
        canv.eventManager.openRecord();
        canv.eventManager.createBuildEvent("create", newGroup);
        canv.eventManager.closeRecord();

        canv.toolBox.TryGetToolByName("cursorTool").setSelectedAndInteraction(newGroup);

        newTextItem.menuMobileEdit(false);
    }

    TryAction(type: string) {
        if (type === "mouseup") {
            this.createText();
        }

        canv.redraw();
    }

    draw() {}

    getAvatar(avatarClass: string) {
        return `

                <div class="${avatarClass}">
                    <p>T</p>
                </div>

            `;
    }

    name = "textTool";
    color = "black";
}
